import { render, staticRenderFns } from "./QRCodePage.vue?vue&type=template&id=6c5b542a&"
import script from "./QRCodePage.vue?vue&type=script&lang=js&"
export * from "./QRCodePage.vue?vue&type=script&lang=js&"
import style0 from "./QRCodePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports